import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "blueShippingCartItem col-12 mb-4" };
const _hoisted_2 = { class: "col-12 bg-white border rounded h-100" };
const _hoisted_3 = {
    class: "row px-2 py-2",
    style: { "border-bottom": "1px solid #dee2e6" }
};
const _hoisted_4 = { class: "col-sm-8 col-10 font7-responsive pl-sm-3 pl-2" };
const _hoisted_5 = { class: "pt-1" };
const _hoisted_6 = { class: "strong mr-2 [ indexNumber ]" };
const _hoisted_7 = {
    class: "row",
    style: { "align-items": "flex-end" }
};
const _hoisted_8 = {
    class: "col-12 col-sm-3 text-center py-3",
    style: { "align-self": "flex-start" }
};
const _hoisted_9 = ["title", "href"];
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = { class: "col-12 col-sm-9 pt-sm-3 pt-1 mb-3" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = {
    class: "col-md-7 mb-3",
    style: { "hyphens": "auto", "word-break": "break-word" }
};
const _hoisted_14 = ["title", "href"];
const _hoisted_15 = { class: "font7-responsive mt-2" };
const _hoisted_16 = { class: "strong" };
const _hoisted_17 = { class: "font7-responsive" };
const _hoisted_18 = { class: "product_article_number" };
const _hoisted_19 = { class: "col-md-5" };
const _hoisted_20 = { class: "col-12 m-0 p-0 pb-2 d-flex justify-content-end" };
const _hoisted_21 = {
    key: 0,
    class: "input-group",
    style: { "max-width": "126px !important" }
};
const _hoisted_22 = { class: "input-group-prepend pointerhover" };
const _hoisted_23 = ["data-id"];
const _hoisted_24 = {
    class: "input-group-append pointerhover",
    style: { "margin-left": "0" }
};
const _hoisted_25 = {
    key: 1,
    class: "input-group mb-md-0 mb-n3"
};
const _hoisted_26 = { class: "col-12 m-0 p-0 text-right" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "stroke-price" };
const _hoisted_29 = { class: "font3 strong mb-0" };
const _hoisted_30 = { key: 1 };
const _hoisted_31 = { class: "font3 strong mb-0" };
const _hoisted_32 = { class: "taxInfo-Formatierung" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formatted_date = _resolveComponent("formatted-date");
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    const _component_formatted_price = _resolveComponent("formatted-price");
    const _component_tax_hint = _resolveComponent("tax-hint");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.index + 1), 1),
                        _cache[4] || (_cache[4] = _createTextVNode(" hinzugefügt am ", -1)),
                        _createVNode(_component_formatted_date, {
                            date: _ctx.cartItem.date_added
                        }, null, 8, ["date"])
                    ])
                ]),
                _createElementVNode("div", {
                    class: "col-sm-4 col-2 font7-responsive pt-1 pr-0 pr-sm-4",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.removeProduct()))
                }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("button", {
                            type: "button",
                            class: "font7 strong btn btn-link text-decoration-none text-secondary float-right p-0"
                        }, [
                            _createElementVNode("svg", {
                                class: "mb-1 mr-1",
                                width: "11",
                                height: "12",
                                viewBox: "0 0 11 12",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                            }, [
                                _createElementVNode("path", {
                                    d: "M1.50016 10.6667C1.50016 11.4 2.10016 12 2.8335 12H8.16683C8.90016 12 9.50016 11.4 9.50016 10.6667V4C9.50016 3.26667 8.90016 2.66667 8.16683 2.66667H2.8335C2.10016 2.66667 1.50016 3.26667 1.50016 4V10.6667ZM9.50016 0.666667H7.8335L7.36016 0.193333C7.24016 0.0733333 7.06683 0 6.8935 0H4.10683C3.9335 0 3.76016 0.0733333 3.64016 0.193333L3.16683 0.666667H1.50016C1.1335 0.666667 0.833496 0.966667 0.833496 1.33333C0.833496 1.7 1.1335 2 1.50016 2H9.50016C9.86683 2 10.1668 1.7 10.1668 1.33333C10.1668 0.966667 9.86683 0.666667 9.50016 0.666667Z",
                                    fill: "#7A7A7A"
                                })
                            ]),
                            _createElementVNode("span", { class: "d-sm-inline d-none" }, "ENTFERNEN")
                        ], -1)
                    ]))])
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", {
                        title: _ctx.cartItem.name,
                        href: 'kaufen/info/' + _ctx.cartItem.name + '__' + _ctx.cartItem.id
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.cartItem.image,
                            title: "Produktabbildung",
                            style: { "width": "90%", "max-height": "8em", "min-height": "4em", "object-fit": "contain" },
                            alt: _ctx.cartItem.name
                        }, null, 8, _hoisted_10)
                    ], 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("a", {
                                title: _ctx.cartItem.name,
                                href: 'kaufen/info/' + _ctx.cartItem.name + '__' + _ctx.cartItem.id,
                                class: "h4-responsive"
                            }, _toDisplayString(_ctx.cartItem.name), 9, _hoisted_14),
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_open_popup_button, { "popup-name": "conditionsPopup" }, {
                                    default: _withCtx(() => [
                                        _cache[6] || (_cache[6] = _createTextVNode(" Zustand: ", -1)),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.cartItem.condition), 1),
                                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "icon-fragezeichen pointerhover" }, null, -1))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _cache[8] || (_cache[8] = _createTextVNode(" Artikelnummer: ", -1)),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.cartItem.cArtNr), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                (_ctx.cartItem.stock_available > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("button", {
                                                class: "btn btn-input",
                                                onClick: _cache[1] || (_cache[1] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.decrement && _ctx.decrement(...args)))
                                            }, "-")
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            readonly: true,
                                            class: "text-center form-control bg-white",
                                            "data-id": _ctx.cartItem.id,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.current_quantity) = $event))
                                        }, null, 8, _hoisted_23), [
                                            [
                                                _vModelText,
                                                _ctx.current_quantity,
                                                void 0,
                                                { number: true }
                                            ]
                                        ]),
                                        _createElementVNode("div", _hoisted_24, [
                                            _createElementVNode("button", {
                                                class: "btn btn-input",
                                                onClick: _cache[3] || (_cache[3] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.increment && _ctx.increment(...args)))
                                            }, "+")
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.cartItem.stock_available === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("input", {
                                                readonly: true,
                                                class: "font7-responsive bg-white form-control text-right border-0 pr-0 user-select-none shadow-none",
                                                value: "Stückzahl: 1"
                                            }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                (_ctx.deal_price)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createVNode(_component_formatted_price, { price: _ctx.original_price }, null, 8, ["price"])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font7-responsive font-weight-light" }, "nur", -1)),
                                            _createVNode(_component_formatted_price, { price: _ctx.deal_price }, null, 8, ["price"])
                                        ])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createVNode(_component_formatted_price, { price: _ctx.total_price }, null, 8, ["price"])
                                        ])
                                    ])),
                                _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_tax_hint, {
                                        tax: _ctx.cartItem.tax_rate
                                    }, null, 8, ["tax"])
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
